export default "__VITE_ASSET__Bwb3OFjx__"